import { auth } from '../firebase';
import { env } from '../config/environment';

export async function fetchActiveVoiceSession() {
  const idToken = await auth.currentUser?.getIdToken();
  if (!idToken) return { active: false };

  const response = await fetch(env.apiEndpoints.voiceActiveSession, {
    headers: { Authorization: `Bearer ${idToken}` },
  });
  if (!response.ok) return { active: false };

  try {
    return await response.json();
  } catch {
    return { active: false };
  }
}
